<template>
  <div class="lc-chat">
    <div class="lc-chat__img-modal-bg" v-if="modalImg" @click="modalImg = null">
      <img class="lc-chat__img-modal" :src="modalImg">
    </div>
    <div class="lc-chat__user" v-if="actUser">
      <div class="lc-chat__user-data">
        <img
          class="lc-chat__user-img"
          :src="actUser.userData.profile_pic"
          v-if="actUser.userData.profile_pic"
        >
        <div class="lc-chat__cont-user-img" v-else>
          <img class="lc-chat__inner-user-img" src="@/assets/chatbotspl_logo_white.png">
        </div>
        <div class="lc-chat__user-wrapper">
          <div class="lc-chat__user-name">{{getUserName}}</div>
        </div>
      </div>

      <div class="lc-chat__user-data lc-chat__user-data--inverted">
        <div class="lc-chat__user-wrapper">
          <sel @input="personaSelect" class="lc-chat__persona-select" v-model="personaId">
            <option :value="null">{{$t('view.livechat.noPersona')}}</option>
            <option
              v-for="persona in personas"
              :key="persona.id"
              :value="persona.id"
            >{{ persona.name }}</option>
          </sel>
        </div>
        <img
          v-if="selectedPersona.profile_picture_url"
          class="lc-chat__user-img lc-chat__user-img--margin-invert"
          :src="selectedPersona.profile_picture_url"
        >
        <div
          v-else
          class="lc-chat__user-img lc-chat__user-img--empty lc-chat__user-img--margin-invert"
        ></div>
      </div>
    </div>
    <div class="lc-chat__msgs-loading" v-if="actUser && !actUser.liveData.loaded">
      <logo-loader ref="loader" color="dark" v-if="!actUser.liveData.loadFailed"></logo-loader>
    </div>
    <div class="lc-chat__msgs" v-show="actUser && actUser.liveData.loaded" ref="refScrl">
      <div v-if="actUser">
        <div
          class="lc-chat__msgs-row"
          v-for="(item, index) in actUser.msgs"
          :class="[!item.user ? 'lc-chat__msgs-row-side' : '']"
          :key="index"
        >
          <div class="lc-chat__msgs-row-item">
            <div v-if="item.attachment" class="lc-chat__attach-msg-wrapper">
              <img
                class="lc-chat__attach-msg"
                :class="(item.state === 'error') ? 'lc-chat__attach-msg--error' : ''"
                :src="item.attachment.url"
                @click="maximizeImg(item.attachment.url)"
              >
              <fai
                v-if="item.state === 'error'"
                @click="resendAttachment(item.uuid)"
                class="lc-chat__attach-msg-resend"
                icon="redo-alt"
              ></fai>

              <fai
                v-if="item.state === 'sending'"
                class="lc-chat__attach-msg-sending"
                icon="spinner"
              ></fai>
            </div>
            <livechat-text-msg
              v-else
              class="lc-chat__text-msg"
              :text="item.message"
              :side="!item.user"
              :notSend="item.notSend"
              @clickedRetry="resendMsg(index)"
            ></livechat-text-msg>
          </div>
          <div class="lc-chat__msgs-row-date" v-if="item.sent_at">{{ displayMsgDate(item.sent_at) }}</div>
        </div>
      </div>
    </div>
    <div class="lc-chat__input-container">
      <div
        class="lc-chat__input-btn lc-chat__btn"
        @click="resolveUser"
        v-if="actUser && actUser.userData.moderator_chat"
        :title="$t('view.livechat.enableBotResponses')"
      >
        <fai icon="robot"></fai>
      </div>
      <div
        class="lc-chat__input-btn lc-chat__btn"
        @click="controlUser"
        v-if="actUser && !actUser.userData.moderator_chat"
        :title="$t('view.livechat.humanTakeover')"
      >
        <fai icon="user"></fai>
      </div>
      <label for="file" class="lc-chat__upload-img-label lc-chat__btn">
        <fai icon="file-image"></fai>
      </label>
      <textarea-autosize
        class="lc-chat__input-text"
        ref="refText"
        v-model="inputText"
        :rows="1"
        @keydown.enter.exact.native.prevent
        @keyup.enter.exact.native="sendMsg"
        :placeholder="$t('view.livechat.messagePlaceholder')"
      ></textarea-autosize>
      <div class="lc-chat__input-btn lc-chat__btn lc-chat__btn--red" @click="sendMsg">
        <fai style="margin-left: -3px" icon="paper-plane"></fai>
      </div>
      <input
        id="file"
        name="file"
        type="file"
        class="lc-chat__upload-img"
        ref="updatedChatImage"
        accept="image/jpeg, image/png"
        @change="sendImg"
      >
    </div>
  </div>
</template>

<script>
import uuid from 'uuid'
import axios from '@/axios'
export default {
  data() {
    return {
      modalImg: null,
      actUser: null,
      inputText: '',
      file: null,
      selectedPersona: {},
      personaId: null,
      pending: {},
      serverFilesMap: {}
    }
  },

  props: {
    value: Object,
    socket: Object,
    personas: Array
  },

  computed: {
    getUserName() {
      return this.actUser.userData.first_name + " " + this.actUser.userData.last_name
    }
  },

  watch: {
    value: function () {
      this.actUser = this.value
    },

    actUser: {
      deep: true,
      handler: async function () {
        this.msgs = this.actUser.msgs

        await this.delayMs(10)
        const el = this.$refs.refScrl
        el.scrollTop = el.scrollHeight
      }
    }
  },

  mounted() {
    if (this.value) this.actUser = this.value
    this.socket.on('sliceRequested', data => {
      let place = data.currentSlice * 100000000
      let slice = this.file.slice(place, place + Math.min(100000, file.size - place))
      this.sendSlice(slice)
    })
    this.socket.on('textSent', textUuid => {
      this.setTextAsSent(textUuid)
    })
    this.socket.on('textSendError', textUuid => {
      this.setTextAsNotSend(textUuid)
    })
    this.socket.on('uploadFinished', this.uploadFinished)
    this.socket.on('uploadError', this.showUploadErrorWarning)
    this.socket.on('imageSendError', this.setImageAsNotSend)
    this.socket.on('imageSent', this.imageSent)
  },

  methods: {
    dateFill(number) {
      if (number <= 9) return '0' + number
      return number
    },

    displayMsgDate(sent_at) {
      const actDate = new Date(sent_at)
      return actDate.getFullYear() + '-' + this.dateFill((actDate.getMonth() + 1)) + '-' + this.dateFill(actDate.getDate())
        + ' ' + this.dateFill(actDate.getHours()) + ':' + this.dateFill(actDate.getMinutes())
    },

    resendMsg(index) {
      let msg = {
        message: this.actUser.msgs[index].message
      }
      let id = uuid()
      this.pending[id] = msg
      this.socket.emit('textMessage', this.actUser.userData, msg.message, id, this.selectedPersona.outside_id)
      this.actUser.msgs.splice(index, 1)
    },

    sendMsg() {
      if (!this.inputText.replace(/\s/g, '').length) return
      let msg = {
        message: this.inputText
      }
      let id = uuid()
      this.pending[id] = msg
      this.socket.emit('textMessage', this.actUser.userData, this.inputText, id, this.selectedPersona.outside_id)
      this.inputText = ''
    },

    async sendImg() {
      try {
        if (this.actUser.userData.communicator_id == 1) {
          const uuid = this.uid()
          this.startSendingImg(uuid)
        }
        else if (this.actUser.userData.communicator_id == 2) {
          const url = await this.uploadToS3(this.$refs.updatedChatImage.files[0])
          this.socket.emit('imageURLMessage', this.actUser.userData, url, this.selectedPersona.outside_id)
          this.actUser.msgs.push({ attachment: { url: url } })
        }
      } catch (e) {
        console.error(e)
      }
    },

    async uploadToS3(file) {
      try {
        const res = await axios.get('/api/livechat/signed-url?type=' + file.type)
        const signedUrl = res.data.url
        const options = {
          headers: {
            'Content-Type': file.type,
            'x-amz-acl': 'public-read'
          }
        }
        const resS3 = await axios.put(signedUrl, file, options)
        return resS3.request.responseURL.replace(/\?.*$/, '')
      } catch (e) {
        throw e
      }
    },

    setTextAsSent(textUuid) {
      if (this.pending[textUuid]) {
        this.pending[textUuid].sent_at = new Date()
        this.actUser.userData.last_msg_date = new Date()
        this.actUser.msgs.push(this.pending[textUuid])
        delete this.pending[textUuid]
      }
    },

    setTextAsNotSend(textUuid) {
      if (this.pending[textUuid]) {
        this.pending[textUuid].notSend = true
        this.actUser.msgs.push(this.pending[textUuid])
        delete this.pending[textUuid]
      }
    },

    showUploadErrorWarning() {
      if (this.$refs.updatedChatImage) this.$refs.updatedChatImage.value = ''
      this.notify('error', 'view.livechat.error.imageUpload')
    },

    findAttachmentIndex(uuid) {
      for (let i = this.actUser.msgs.length - 1; i >= 0; i--) {
        const m = this.actUser.msgs[i]
        if (m.attachment && m.uuid === uuid) return i
      }
    },

    setImageAsNotSend(uuid) {
      setTimeout(() => {
        for (let i = this.actUser.msgs.length - 1; i >= 0; i--) {
          const m = this.actUser.msgs[i]
          if (m.attachment && m.uuid === uuid) {
            m.state = 'error'
          }
        }
      }, 0);
    },

    resendAttachment(uuid) {
      const fileName = this.serverFilesMap[uuid]
      const index = this.findAttachmentIndex(uuid)
      this.actUser.msgs.splice(index, 1)
      this.uploadFinished(uuid, fileName)
    },

    startSendingImg(uuid) {
      this.file = this.$refs.updatedChatImage.files[0]
      let slice = this.file.slice(0, 100000000)
      this.sendSlice(slice, uuid)
    },

    sendSlice(slice, uuid) {
      let reader = new FileReader()
      reader.readAsArrayBuffer(slice)
      let that = this
      reader.onload = () => {
        let arrayBuffer = reader.result
        that.socket.emit('sliceUpload', {
          name: that.file.name,
          type: that.file.type,
          size: that.file.size,
          data: arrayBuffer,
          uuid
        })
      }
    },

    uploadFinished(uuid, fileName) {
      this.serverFilesMap[uuid] = fileName
      this.socket.emit('sendUploadedImage', this.actUser.userData.outside_id, fileName, this.selectedPersona.outside_id, uuid)
      let reader = new FileReader()
      reader.readAsDataURL(this.file)
      reader.onload = () => {
        this.actUser.msgs.push({ uuid, state: 'sending', attachment: { url: reader.result } })
      }
      if (this.$refs.updatedChatImage) this.$refs.updatedChatImage.value = ''
    },

    controlUser() {
      this.socket.emit('controlUser', this.actUser.userData.outside_id)
    },

    resolveUser() {
      this.socket.emit('userResolved', this.actUser.userData.outside_id)
    },

    maximizeImg(img) {
      this.modalImg = img
    },

    personaSelect(v) {
      if (!v) this.selectedPersona = {}
      for (let persona of this.personas) {
        if (persona.id == v) {
          this.selectedPersona = persona
          break
        }
      }
    },

    imageSent(uuid) {
      const i = this.findAttachmentIndex(uuid)
      this.actUser.msgs[i].state = 'sent'
      this.actUser.userData.last_msg_date = new Date()
    }
  }
}
</script>

<style lang="scss">
.lc-chat {
  display: flex;
  flex-direction: column;

  &__img-modal-bg {
    background-color: rgba(1, 1, 1, 0.7);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
  }

  &__img-modal {
    position: absolute;
    max-height: 80vh;
    max-width: 80vw;
  }

  &__user {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }

  &__user-data {
    @include boxShadow(-2px, 2px, 14px, -10px, rgba(0, 0, 0, 0.3));
    background: white;
    border-radius: 8px;
    font-size: 1.1em;
    padding: 8px 10px;
    display: flex;
    align-items: center;
    width: 270px;

    &--inverted {
      justify-content: flex-end;
    }
  }

  &__user-img {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    margin-right: 14px;
    object-fit: cover;

    &--margin-invert {
      margin: 0 0 0 14px;
    }

    &--empty {
      background-color: $bgGrey;
    }
  }

  &__cont-user-img {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    margin-right: 14px;
    background-color: $primary;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__inner-user-img {
    margin-top: 2px;
    width: 55%;
    height: 55%;
  }

  &__msgs-loading {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  &__msgs-loading-cont {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__msgs-loading-text {
    font-size: 1.2em;
  }

  &__msgs {
    flex-grow: 1;
    margin-bottom: 8px;
    border-radius: 6px;
    overflow-x: auto;
  }

  &__msgs-row {
    padding: 3px;
    display: flex;
    align-items: center;
  }

  &__msgs-row-side {
    flex-direction: row-reverse;
  }

  &__msgs-row-date {
    font-size: 0.8em;
    color: #a4a4a4;
    padding: 0px 18px 0px 18px;
    visibility: hidden;
  }

  &__msgs-row:hover > &__msgs-row-date {
    visibility: visible;
  }

  &__msgs-row-item {
    max-width: 40%;
  }

  &__attach-msg {
    @include boxShadow(-2px, 2px, 9px, -10px, rgba(0, 0, 0, 1));
    cursor: pointer;
    max-width: 100%;
    max-height: 300px;
    border-radius: 10px;
  }

  &__attach-msg:hover {
    @include boxShadow(-2px, 2px, 20px, -10px, $primary);
  }

  &__attach-msg--error,
  &__attach-msg--error:hover {
    @include boxShadow(0px, 0px, 12px, 0px, $danger);
  }

  &__attach-msg-wrapper {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  }

  &__attach-msg-resend {
    margin-right: 10px;
    cursor: pointer;
  }

  &__attach-msg-sending {
    margin-right: 10px;
    color: $inactiveGrey;
    animation: rotation 1s infinite;
    animation-timing-function: linear;
  }

  &__input-container {
    display: flex;
    align-items: flex-end;
  }

  &__input-container--inactive {
    pointer-events: none;
  }

  &__input-text {
    @include boxShadow(-2px, 2px, 11px, -10px, rgba(0, 0, 0, 0.3));
    background: white;
    padding: 9px 10px 0px 10px;
    font-size: 1em;
    margin: 0 6px;
    border-radius: 1.3em;
    flex-grow: 1;
    border: 1px solid $borderGrey;
    font-family: inherit;
    outline: none;
    resize: none;
  }

  &__upload-img {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }

  &__persona-select {
    width: 210px;
  }

  &__btn {
    @include boxShadow(-2px, 2px, 14px, -10px, rgba(0, 0, 0, 0.8));
    background: $primary;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    border-radius: 3em;
    cursor: pointer;
    user-select: none;
    margin: 0 3px;
    text-align: center;
    width: 38px;
    height: 38px;

    &:hover {
      background-color: $primaryHover;
    }

    & > * {
      margin-top: -1px;
    }

    &--red {
      background-color: $danger;

      &:hover {
        background-color: $dangerHover;
      }
    }
  }
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
